import React, { useEffect } from 'react';

interface SeoProps {
    title: string;
    description: string;
    canonical: string;
    ogType?: string;
    /** 页面级结构化数据，页面实际展示对应内容时才传入 */
    jsonLd?: object[];
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
    let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

/**
 * 为每个页面设置独立的 Title、Meta Description、Canonical 和页面级 JSON-LD。
 * 预渲染构建时这些内容会被写入各路由的初始 HTML。
 */
const Seo: React.FC<SeoProps> = ({ title, description, canonical, ogType = 'website', jsonLd = [] }) => {
    const jsonLdKey = JSON.stringify(jsonLd);

    useEffect(() => {
        document.title = title;

        upsertMeta('name', 'description', description);
        upsertMeta('property', 'og:title', title);
        upsertMeta('property', 'og:description', description);
        upsertMeta('property', 'og:url', canonical);
        upsertMeta('property', 'og:type', ogType);

        let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }
        link.setAttribute('href', canonical);

        // 移除上一个页面注入的 JSON-LD，避免跨页面残留
        document.head.querySelectorAll('script[data-seo-jsonld="true"]').forEach((node) => node.remove());
        (jsonLd as object[]).forEach((obj) => {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.setAttribute('data-seo-jsonld', 'true');
            script.textContent = JSON.stringify(obj);
            document.head.appendChild(script);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, description, canonical, ogType, jsonLdKey]);

    return null;
};

export default Seo;
